import React from 'react';
import { Button, Typography } from '@rbx/ui';
import useRailStyles from './Rail.styles';

type TRailHeaderProps = {
  icon: React.ReactNode;
  href: string;
  label: string;
  compact: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const RailHeader: React.FC<TRailHeaderProps> = ({ icon, href, label, compact, onClick }) => {
  const {
    cx,
    classes: { header, headerContainer, startIcon, headerLabel, hidden, label: labelClass },
  } = useRailStyles();

  return (
    <div className={headerContainer}>
      <Button
        href={href}
        onClick={onClick}
        variant='text'
        disableRipple
        classes={{
          root: header,
          startIcon,
        }}
        color='primary'
        startIcon={icon}>
        <Typography
          variant='hero'
          classes={{
            root: cx(labelClass, headerLabel, {
              [hidden]: compact,
            }),
          }}>
          {label}
        </Typography>
      </Button>
    </div>
  );
};

export default RailHeader;
